/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import "DesignSystem/Fonts/Inter-500.css"
import FiltersAction from './FiltersAction/index'
import Info from 'DesignSystem/Info/index'
import NewThreadAction from './NewThreadAction/index'
import NoSearchResult from 'DesignSystem/Images/NoSearchResult/index'
import React from 'react'
import SupportLink from './SupportLink/index'
import TagLabel from 'DesignSystem/TagLabel/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Empty"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-4PwO0': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<NoSearchResult
  viewPath={`${viewPath}/NoSearchResult`}
 width={150}
 height="auto"
/>
<span
  data-testid="Empty.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
No matches found
</span>
<NewThreadAction
  viewPath={`${viewPath}/NewThreadAction`}
/>
<Info
  viewPath={`${viewPath}/Info`}
 marginTop={32}
 color="rgba(0,0,0,0.5)"
 text="Or try to refine your search:"
/>
<div
  data-testid="Empty.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 tagText="MM/DD/YYYY"
 labelText="Date of birth"
 width={100}
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={4}
 tagText="john@abcd.com"
 labelText="Email"
 width={100}
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={4}
 tagText="1234a"
 labelText="Greyfinch person ID"
 width={100}
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={4}
 tagText="111-22-3333"
 labelText="SSN"
 width={100}
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={4}
 tagText="W123456789"
 labelText="Insurance member ID"
 width={100}
/>
<FiltersAction
  viewPath={`${viewPath}/FiltersAction`}
/>
</div>
<SupportLink
  viewPath={`${viewPath}/SupportLink`}
/>
</div>
{children}
</React.Fragment>)
}